var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value > 0)?_c('v-progress-linear',{attrs:{"color":"light-blue","height":"5","value":_vm.value,"fixed":"","bottom":this.$vuetify.breakpoint.smAndDown ? false : true}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }